import { i18n } from '@/plugins/vue-i18n';
import tags from './tags';
import searches from './searches';
import clipboard from './clipboard';


// Available tabs
export const tabs = {
  INTERNAL_TAGS: 'internal_tags',
  SAVED_SEARCHES: 'saved_searches',
  CLIPBOARD: 'clipboard',
};

// Default tab
export const defaultTab = tabs.SAVED_SEARCHES;

export default {
  namespaced: true,
  state: {
    tab: defaultTab,
    loading: false,
  },
  getters: {
    availableTabs(state, getters) {
      const result = [
        { label: i18n.t(`message.bag.tabs.${tabs.SAVED_SEARCHES}`), id: tabs.SAVED_SEARCHES },
        { label: i18n.t(`message.bag.tabs.${tabs.INTERNAL_TAGS}`), id: tabs.INTERNAL_TAGS },
      ];

      if (getters['clipboard/active']) {
        result.push({ label: i18n.t(`message.bag.tabs.${tabs.CLIPBOARD}`), id: tabs.CLIPBOARD });
      }

      return result;
    },
    canReceiveContents(state, getters): Boolean {
      if (state.tab === tabs.INTERNAL_TAGS) {
        return getters['tags/canReceiveContents'];
      }
      return false;
    },
  },
  actions: {
    async ADD_CONTENT({ dispatch, commit, state }, content) {
      try {
        if (state.tab === tabs.INTERNAL_TAGS) {
          commit('SET_LOADING', true);
          await dispatch('tags/ADD_CONTENT', content);
        }
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async DELETE_CONTENT({ dispatch, commit, state }, content) {
      try {
        if (state.tab === tabs.INTERNAL_TAGS) {
          commit('SET_LOADING', true);
          await dispatch('tags/DELETE_CONTENT', content);
        }
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async CHANGE_TAB({ commit }, tab) {
      commit('SET_TAB', tab);
    },
    async RESET_TABS({ commit }) {
      commit('SET_TAB', defaultTab);
    },
    async ITEM_SELECTED(context, item) {
      // Use this action as an event to subscribe
    },
  },
  mutations: {
    SET_TAB: (state, tab) => {
      state.tab = tab;
    },
    SET_LOADING: (state, loading) => {
      state.loading = loading;
    },
  },
  modules: {
    tags,
    searches,
    clipboard,
  },
};
